import { Util } from "../core/cafm.util.jsx";

export class Scanner {

    constructor(settings) {
        this.settings = settings;
        this.formStep = cafm.enums.ScanFormStep.Scanning;
        this.videoElement = document.getElementById("scan-video");
        this.videoElement.playsInline = true;
        this.videoWrapper = document.querySelector(".video-wrapper");
        this.canvasElement = document.getElementById("canvas");
        this.toolbarElement = document.getElementById("scan-toolbar");
        this.scanBtn = document.getElementById("scan-btn");
        this.scanAgainBtn = document.getElementById("scan-again-btn");
        this.videoSelect = document.querySelector('select[name="VideoSource"]');
        this.zoomSliderLabel = document.querySelector('#streamzoom-label');
        this.zoomSlider = document.querySelector('#streamzoom');
        this.mediaStreamTrack = null;
        this.videoSources = new Array();
        this.initialising = true;
        this.maxScanWidth = 500;
        this.scanLocalityCacheKey = "ScanLocality";        

        if (!$(this.toolbarElement).closest(".mainContentPane").length) {

            this.toolbarElement.className += ` ${cafm.res.consts.CssClass_WindowButtons}`;
        }

        let n = cafm.enums.Navigatable;
        this.isWorkOrderScan = cafm.nav.isNav(n.HelpdeskNewWorkOrder, n.HelpdeskEditWorkOrder, n.HelpdeskConfirmWorkOrder) && settings.parentType === cafm.enums.ModelKey.WorkOrder;
        this.reader = new ZXingGenericReader(this);
    }

    setup() {
        let me = this;
        // once the video element is ready, resize it and add window resize event
        this.videoElement.onloadeddata = () => {
            me.resizeVideo();
            $(window).off("resize.scanner").on("resize.scanner", () => me.resizeVideo());
        }
        // if ios get the stream first as permission is required to get devices
        if (cafm.browsers.isIos()) this.getStream();
        // if android get the video sources first as a deviceId is required to get the stream
        else this.setupVideoSelection();            
        // run pre scan
        this.reader.preScan();
        console.info('Scanner setup');
        return this;
    }

    handleError(error) {
        console.error('Error: ', error);
    }

    resizeVideo() {
        if (!$(".scan-form").length) {
            $(window).off("resize.scanner");
            return;
        }
        let targWidth = $(this.canvasElement).closest(".scan-form-container").width(), elWidth, elHeight;
        if (targWidth > this.maxScanWidth) targWidth = this.maxScanWidth;
        if (this.videoElement.videoWidth > targWidth) {
            let ratio = targWidth / this.videoElement.videoWidth;
            elWidth = targWidth;
            elHeight = this.videoElement.videoHeight * ratio;
        }
        else if (targWidth > this.videoElement.videoWidth) {
            let ratio = this.videoElement.videoWidth / targWidth;
            elWidth = targWidth;
            elHeight = this.videoElement.videoHeight * ratio;
        }
        document.getElementById("scan-form").style.width = "{0}px".format(elWidth);
        this.videoElement.width = elWidth;
        this.videoElement.height = elHeight;
        this.videoWrapper.height = elHeight;
    }

    setupVideoSelection() {
        let me = this;
        let gotDevices = function (deviceInfos) {
            if (deviceInfos.length) {
                // create the select items from the device infos
                for (let i = deviceInfos.length - 1, c = 0; i >= 0; --i) {
                    let deviceInfo = deviceInfos[i];
                    if (deviceInfo.kind === 'videoinput') {
                        me.videoSources.push({
                            value: deviceInfo.deviceId,
                            text: deviceInfo.label || 'Camera ' + (++c)
                        });
                    }
                }
                // ensure device id is 1st item or from cache
                if (me.videoSources.length) {
                    let devId = cafm.cache.get("ScanningDeviceId", me.videoSources[0].value);
                    me.deviceId = cafm.util.findByFieldValue(me.videoSources, "value", devId) != null ? devId : me.videoSources[0].value;
                }
                // populate the dropdown, with a delay to ensure control is ready
                cafm.util.callFunctionAsync({
                    func: () => {
                        let sourceKdl = $("[name=VideoSource]").getKendoDropDownList();
                        sourceKdl.dataSource.data(me.videoSources);
                        sourceKdl.value(me.deviceId);
                        if (me.videoSources.length <= 1) {
                            sourceKdl.enable(false);
                        }
                    },
                    timeout: 500
                });
                me.initialising = false;                
            }
        }

        // hook up video select change event
        me.videoSelect.onchange = (e) => {
            // set device id
            me.deviceId = e.target.value;
            cafm.cache.set("ScanningDeviceId", me.deviceId);
            // stop the stream
            me.stop();
            // get new stream
            me.getStream();
        };

        // get the devices
        let promise = navigator.mediaDevices.enumerateDevices()
            .then(gotDevices);
        // get the video stream if not ios - ios requires the stream is retrieved first
        if (!cafm.browsers.isIos()) promise.then(() => me.getStream());
        promise.catch(me.handleError);
    }

    getStream(onGotStream) {
        let me = this;
        let enableScan = (source) => {
            if (source) {
                cafm.util.doWhen(() => {
                    me.scanBtn.disabled = false;
                    me.scanBtn.title = "Click to start scanning";
                }, () => {
                    return !isNullOrUndefined(window.ZXing && window.ZXingJs);
                })
            }
            else {
                me.scanBtn.disabled = true;
                me.scanBtn.title = "No video source found - cannot scan";
            }
        }

        let gotStream = (stream) => {
            me.stream = stream;
            me.videoElement.srcObject = stream;

            //Allow zoom
            me.mediaStreamTrack = stream.getVideoTracks()[0];
            var capabilities = me.mediaStreamTrack.getCapabilities();
            var settings = me.mediaStreamTrack.getSettings();
            if (capabilities.zoom) {
                me.zoomSlider.style.visibility = "visible";
                me.zoomSliderLabel.style.visibility = "visible";
                
                me.zoomSlider.min = capabilities.zoom.min;
                me.zoomSlider.max = capabilities.zoom.max;
                me.zoomSlider.step = capabilities.zoom.step;
                var midZoom = Math.round((capabilities.zoom.min + capabilities.zoom.max) / 2);
                settings.zoom = midZoom;
                me.zoomSlider.value = settings.zoom;
                //Set to mid value
                me.mediaStreamTrack.applyConstraints({ advanced: [{ zoom: midZoom }] })
                    .catch(error => console.error('Uh, oh, applyConstraints() error:', error));

                //Slider events
                //On Change for updating the changed value
                me.zoomSlider.addEventListener("change", function () {
                    me.mediaStreamTrack.applyConstraints({ advanced: [{ zoom: me.zoomSlider.value }] })
                        .catch(error => console.error('Uh, oh, applyConstraints() error:', error));
                });
                //Use input to provide live update when dragging
                me.zoomSlider.addEventListener("input", function () {
                    me.mediaStreamTrack.applyConstraints({ advanced: [{ zoom: me.zoomSlider.value }] })
                        .catch(error => console.error('Uh, oh, applyConstraints() error:', error));
                });
            }
            else {
                me.zoomSlider.style.visibility = "hidden";
                me.zoomSliderLabel.style.visibility = "hidden";
            }

            $(".scan-prep-msg").remove();
            // show scan target video overlay
            cafm.util.callFunctionAsync({
                func: () => {
                    enableScan(me.videoSelect.value);
                    Util.callFunction(onGotStream);
                    console.info('Scanner ready');
                    cafm.handlers.exe("onScanReady");
                },
                timeout: 1000
            });
        }

        let constraints = {
            audio: false
        };
        let dId = me.deviceId || cafm.cache.get("ScanningDeviceId");
        if (dId) constraints.video = { deviceId: { exact: dId } }
        else constraints.video = true;

        let mediaPromise = navigator.mediaDevices.getUserMedia(constraints)
            .then(gotStream)
            .catch(me.handleError);

        if (me.initialising) {
            mediaPromise.then(() => { me.setupVideoSelection() });
        }
    }

    stop() {
        if (this.stream) {
            this.stream.getTracks().forEach(function (track) {
                track.stop();
            });
            delete this.stream;
        }
        if (this.videoElement) {
            this.videoElement.pause();
            this.videoElement.srcObject = null; // empty source
            this.videoElement.load();
        }
        this.reader.stop();
    }

    postScan() {
        //if (isMobile) this.stop();
        this.scanBtn.disabled = false;
        this.scanBtn.title = "Click to start scanning";
    }

    setFormStep(step, data) {

        if (data) {
            if (cafm.util.hasStringVal(data.barcode)) {
                this.barcode = data.barcode;
            }
            else if (isObj(data.barcode) && cafm.util.hasStringVal(data.barcode.Value)) {
                this.barcode = data.barcode.Value;
            }
        }

        let me = this;
        switch (step) {
            case cafm.enums.ScanFormStep.Scanning:
                $("#scan-result-container,#scan-result,#scan-assign,#scan-nav-btn,#scan-assign-btn,#scan-reassign-btn,#scan-result-msg,#scan-add-btn,#scan-again-btn,#scan-create-asset-btn,#scan-create-asset,#scan-update-asset,#scan-save-asset-btn,#scan-edit-asset-btn,#scan-log-wo-btn").hide();
                $("#scan-result-container").removeClass("full-size");
                $("#scan-btn,#scan-form-container").show();
                $("#scan-btn").prop("disabled", false);
                break;
            case cafm.enums.ScanFormStep.ScannedItemPending:
                if (isMobile) $("#scan-form-container").hide();
                $("#scan-btn,#scan-result-msg").hide();
                $("#scan-result-container").show();
                break;
            case cafm.enums.ScanFormStep.ScannedItemRecognised:
                if (isMobile) $("#scan-form-container").hide();
                $("#scan-btn,#scan-result-msg,#scan-again-btn").hide();
                $("#scan-result-container,#scan-result,#scan-again-btn").show();
                let barcode = $("#scan-result").getViewModel();
                if (this.isWorkOrderScan) {
                    let addBtn = $("#scan-add-btn");
                    if (!barcode.IsAsset || cafm.assets.getWorkOrderAsset(barcode.Entity.ID)) {
                        $("#scan-nav-btn").show();
                    }
                    else {
                        addBtn.show();
                    }
                    addBtn.prop("disabled", !cafm.scanner.isAllowed(cafm.scanner.SecurityCheck.Add, this.isWorkOrderScan, barcode))
                }
                else {
                    $("#scan-nav-btn").show();
                }
                if (!this.isUrlScanResult() && cafm.scanner.isAllowed(cafm.scanner.SecurityCheck.Assign)) {
                    $("#scan-reassign-btn").show();
                }
                if (barcode.IsAsset && cafm.scanner.isAllowed(cafm.scanner.SecurityCheck.UpdateAsset, this.isWorkOrderScan)) {
                    $("#scan-edit-asset-btn").show();
                }
                if (cafm.scanner.isAllowed(cafm.scanner.SecurityCheck.LogWorkOrder, this.isWorkOrderScan, barcode)) {
                    $("#scan-log-wo-btn").show();
                }
                break;
            case cafm.enums.ScanFormStep.ScannedItemNotRecognised:
                $("#scan-result").hide();
                if (isMobile) $("#scan-form-container").hide();
                $("#scan-result-container,#scan-again-btn").show();

                if (!this.isUrlScanResult()) {
                    let canAssign = cafm.scanner.isAllowed(cafm.scanner.SecurityCheck.Assign, this.isWorkOrderScan);
                    let canCreate = cafm.scanner.isAllowed(cafm.scanner.SecurityCheck.CreateAsset, this.isWorkOrderScan);
                    $("#scan-result-msg .msgPnl").removeClass("staticMsgPnl");
                    if (canAssign && canCreate) {
                        let buttons = [];
                        if (canAssign) {
                            buttons.push({ text: this.settings[this.isWorkOrderScan ? "assignWorkOrderAssetMessage" : "assignMessage"], click() { me.setFormStep(cafm.enums.ScanFormStep.ScannedItemAssign, data) } });
                        }
                        if (canCreate) {
                            buttons.push({ text: this.settings[this.isWorkOrderScan ? "createWorkOrderAssetMessage" : "createAssetMessage"], click() { me.setFormStep(cafm.enums.ScanFormStep.ScannedItemAssetCreate, data) } });
                        }
                        $("#scan-result-msg").showMessage({
                            title: this.settings.notRecognisedActionMessage,
                            type: cafm.enums.MessageType.Untyped,
                            buttons
                        }).show();
                    }
                    else if (canAssign) {
                        this.setFormStep(cafm.enums.ScanFormStep.ScannedItemAssign, data);
                    }
                    else if (canCreate) {
                        this.setFormStep(cafm.enums.ScanFormStep.ScannedItemAssetCreate, data);
                    }
                }
                break;
            case cafm.enums.ScanFormStep.ScannedItemAssign:
                if (cafm.scanner.isAllowed(cafm.scanner.SecurityCheck.Assign)) {
                    $("#scan-result-container").hideMessage(true);
                    this.bindAssignForm(this.barcode, this.isWorkOrderScan ? this.settings.assignWorkOrderAssetMessage : this.settings.assignMessage);
                    $("#scan-btn,#scan-result-msg").hide();
                    $("#scan-assign-btn,#scan-assign").show();
                }
                break;
            case cafm.enums.ScanFormStep.ScannedItemAssetCreate:
                if (cafm.scanner.isAllowed(cafm.scanner.SecurityCheck.CreateAsset)) {
                    $("#scan-result-container").hideMessage(true);
                    this.bindAssetForm({
                        Barcode: this.barcode,
                        _fieldSetTitle: this.settings[this.isWorkOrderScan ? "createWorkOrderAssetMessage" : "createAssetMessage"]
                    });
                    $("#scan-form-container").hide();
                    $("#scan-result-container").addClass("full-size");
                    $("#scan-log-wo-btn,#scan-assign-btn,#scan-assign,#scan-create-asset-btn").hide();
                    $("#scan-create-asset,#scan-save-asset-btn").show();
                }
                break;
            case cafm.enums.ScanFormStep.ScannedItemAssetCreated:
                $("#scan-create-asset,#scan-save-asset-btn").hide();
                let buttons;
                if (this.isWorkOrderScan) {
                    buttons = [{ text: me.settings.addToWorkOrderLabel, click(args) { me.add(args, data.ID) } }];
                }
                $("#scan-result-msg").showMessage({
                    title: me.settings.createAssetSuccessMessageTemplate.format(data.Description),
                    type: cafm.enums.MessageType.Success
                }).show();
                $("#scan-toolbar [disabledbyloading=true]").css("visibility", "visible").prop("disabled", false).removeAttr("disabledbyloading"); // TODO: why is this required on mobile only - refactor this out
                break;
            case cafm.enums.ScanFormStep.ScannedItemAssetUpdate:
                if (cafm.scanner.isAllowed(cafm.scanner.SecurityCheck.UpdateAsset, this.isWorkOrderScan)) {
                    $("#scan-log-wo-btn,#scan-nav-btn,#scan-edit-asset-btn,#scan-form-container,#scan-result,#scan-reassign-btn,#scan-add-btn").hide();
                    $("#scan-result-container").hideMessage(true);
                    $("#scan-result-container").addClass("full-size");
                    $("#scan-create-asset,#scan-save-asset-btn").show();
                    data._fieldSetTitle = this.settings[this.isWorkOrderScan ? "updateWorkOrderAssetMessage" : "updateAssetMessage"];
                    this.bindAssetForm(data);
                    break;
                }
            case cafm.enums.ScanFormStep.ScannedItemAssetUpdated:
                $("#scan-create-asset,#scan-save-asset-btn").hide();
                $("#scan-result-msg").showMessage({
                    title: me.settings.updateAssetSuccessMessageTemplate.format(data.Description),
                    type: cafm.enums.MessageType.Success
                }).show();
                $("#scan-toolbar [disabledbyloading=true]").css("visibility", "visible").prop("disabled", false).removeAttr("disabledbyloading"); // TODO: why is this required on mobile only - refactor this out
                break;
            case cafm.enums.ScanFormStep.ScannedItemReassign:
                if (cafm.scanner.isAllowed(cafm.scanner.SecurityCheck.Assign)) {
                    $("#scan-result-container").hideMessage(true);
                    if (isMobile) $("#scan-form-container").hide();
                    $("#scan-result-container,#scan-again-btn").show();
                    this.bindAssignForm(this.barcode, this.isWorkOrderScan ? this.settings.reassignWorkOrderAssetMessage : this.settings.reassignMessage);
                    $("#scan-log-wo-btn,#scan-btn,#scan-nav-btn,#scan-add-btn,#scan-reassign-btn,#scan-create-asset-btn,#scan-result,#scan-result-msg,#scan-edit-asset-btn").hide();
                    $("#scan-assign-btn,#scan-assign").show();
                }
                break;
            case cafm.enums.ScanFormStep.ScannedItemAssigned:
                $("#scan-result-container > .msgPnl,#scan-assign,#scan-assign-btn").hide();
                $("#scan-again-btn,#scan-result-msg").show();
                break;
        }
        this.formStep = step;
    }

    bindAssignForm(barcode, title) {

        let mk, me = this;

        if (me.isWorkOrderScan) {
            mk = cafm.enums.ModelKey.AssetInfo;
        }
        else {
            mk = this.getDefaultScanType() || cafm.enums.ModelKey.Unknown;
        }

        let vm = $("#scan-assign").getViewModel(), vmVals = {
            ModelKey: mk,
            EntityID: cafm.guid.empty,
            EntityDescription: '',
            IsAsset: this.isAssetType(mk),
            IsBuilding: mk == cafm.enums.ModelKey.Building,
            IsFloor: mk == cafm.enums.ModelKey.Floor,
            IsZone: mk == cafm.enums.ModelKey.Zone,
            IsSpace: mk == cafm.enums.ModelKey.Space,
            IsRoom: mk == cafm.enums.ModelKey.Room,
            IsWorkgroup: mk == cafm.enums.ModelKey.Workgroup,
            BarcodeValue: barcode,
            IsScanTypeVisible: !me.isWorkOrderScan,
            _fieldSetTitle: title
        };

        if (vm) {
            vm.set(vmVals);
        }
        else {
            vm = $("#scan-assign").bindViewModel(vmVals).getViewModel();
        }

        vm.bind('change', function (args) {

            if (args.field == "ModelKey") {

                let mk = vm.ModelKey;

                vm.set({
                    EntityID: cafm.guid.empty,
                    EntityDescription: '',
                    IsAsset: me.isAssetType(mk),
                    IsBuilding: mk == cafm.enums.ModelKey.Building,
                    IsFloor: mk == cafm.enums.ModelKey.Floor,
                    IsZone: mk == cafm.enums.ModelKey.Zone,
                    IsSpace: mk == cafm.enums.ModelKey.Space,
                    IsRoom: mk == cafm.enums.ModelKey.Room,
                    IsWorkgroup: mk == cafm.enums.ModelKey.Workgroup
                });
            }
        });
    }

    bindAssetForm(data) {
        if (!data) throw new Error("data is missing on call to bindAssetForm");
        let isUpdate = cafm.util.guidHasValue(data.ID),
            element = $(`#scan-create-asset`).bindViewModel(data),
            vm = element.getViewModel(),
            me = this;
        //#region reset form elements
        if (isUpdate)
            element.css("visibility", "hidden");
        else element.find(".scan-action-next-step:first").hide();
        element.find(".k-invalid-msg").remove();
        element.find(".k-invalid-field").removeClass("k-invalid-field k-invalid");
        element.find(".k-invalid").removeClass("k-invalid");
        $("#asset-rooms-container").removeData("url");
        //#endregion
        //#region locality specific functionality
        let applyLocality = (locality, onBind) => {
            vm.set({
                LocalityID: locality.LocalityID,
                LocalityTrail: locality.LocalityTrail
            });
            element.find(".cfLookup:not(.forLocality)").ensureDataLocalityId(locality);
            element.find("input[data-autocomplete]").ensureDataLocalityId(locality); 
            if (onBind !== true) {                   
                
            }
        }
        if (this.isWorkOrderScan && !isUpdate) {
            let loc = cafm.hd.workOrder.LocalityDescription;
            if (loc) {
                applyLocality(loc, true);
            }
        }
        else if (!this.isWorkOrderScan) {
            let locality = cafm.cache.get(me.scanLocalityCacheKey);
            if (locality) {
                applyLocality(locality, true);
            }
        }
        //#endregion
        //#region panelbar setup and navigation
        let panelBar = $("#scan-create-asset").getKendoPanelBar();
        panelBar.element.find("> .k-item").each((i, el) => {
            let item = $(el);
            if (item.data("key") == "AssetDetails") {
                panelBar.expand(item);
            }
            else {
                panelBar.collapse(item);
            }
        });
        panelBar.element.off("click.cafm").on("click.cafm", ".scan-action-next-step, .scan-action-prev-step", args => {
            let btn = $(args.currentTarget);
            let item = btn.closest(".k-item");
            if (btn.hasClass("scan-action-next-step")) {
                if (item.validateElement()) {
                    let nextItem = item.next();
                    if (item.data("key") == "AssetDetails" && nextItem.data("key") == "AdditionalDetails") {
                        cafm.hi.getLocality(vm.LocalityID, locality => {
                            applyLocality(locality);
                            cafm.cache.set(me.scanLocalityCacheKey, locality);
                            panelBar.collapse(item);
                            panelBar.expand(item.next());
                        }, element);
                        return;
                    }
                    else if (nextItem.data("key") == "AssignRooms") {
                        let loc = cafm.cache.get(me.scanLocalityCacheKey);
                        let roomsUrl;
                        let locId = cafm.util.guidHasValue(loc.LocationID) ? loc.LocationID : loc.CompanyID;
                        if (isUpdate) {
                            roomsUrl = `scanner/assignrooms/${locId}/${vm.ID}`;
                        }
                        else {
                            roomsUrl = `scanner/assignrooms/${locId}`;
                        }
                        let container = $("#asset-rooms-container")
                        if (container.data("url") != roomsUrl) {
                            container.loadView({
                                loaderSelector: cafm.scanner.loaderSelector(),
                                url: cafm.url.get(roomsUrl),
                                onLoad(panel) {
                                    panel.data("url", roomsUrl);
                                    panelBar.collapse(item);
                                    panelBar.expand(item.next());
                                    cafm.util.callFunctionAsync(() => $("#roomGrid .cGrd").getKendoGrid().refresh());
                                }
                            });
                            return;
                        }
                    }
                    panelBar.collapse(item);
                    panelBar.expand(item.next());
                }
            }
            else {
                panelBar.collapse(item);
                panelBar.expand(item.prev());
            }
        });
        //#endregion
        //#region asset type specific functionality and labelling
        // always set reference required when editing as it's not possible to clear the reference on an asset when updating
        let ref = element.find(".cfTextInput[name=Reference]");
        if (ref.prop("required") === false && isUpdate)
            ref.prop("required", true);
        // set asset type enabled or not
        element.find("[name=AssetType]").getKendoDropDownList().enable(!isUpdate);
        let setAssetType = key => {
            element.find(".k-invalid-msg").remove();
            element.find(".k-invalid-field").removeClass("k-invalid-field");
            element.find(".k-invalid").removeClass("k-invalid");
            cafm.actions.execute({
                url: cafm.url.api(`Asset/GetAssetFieldLocalisationData/${key}`),
                loaderTarget: cafm.views.getActionPanelElement(),
                loaderDelay: 1000,
                method: "GET",
                success(data) {
                    data.forEach(field => {
                        let control = element.find(`[name=${field.Name.replace(/\./g, "_")}]`);
                        if (field.ValidationMessage) control.attr("validationmessage", field.ValidationMessage)
                        let wrapper = control.closestField()
                        wrapper.find("label").text(field.Label);
                        if (field.Title) {
                            wrapper.data("title", field.Title);
                        }
                    });
                    element.find(".k-item[data-key=AssetDetails]").find(".cfField:not(:visible)").show();
                    if (element.css("visibility") == "hidden")
                        element.css("visibility", "visible");
                    else 
                        element.find(".scan-action-next-step:first").show();
                }
            });
        }
        if (!isUpdate) {
            element.find(".k-item[data-key=AssetDetails]").find(".cfField:not(:first-child)").hide();
            vm.bind("change", args => {
                if (args.field == "AssetType") {
                    setAssetType(cafm.enums.getEnumKey(cafm.enums.AssetType, vm.AssetType ? parseInt(cafm.util.getItemValue(vm.AssetType)) : cafm.enums.AssetType.All));
                }
            });
        }
        else {
            setAssetType(cafm.enums.getEnumKey(cafm.enums.AssetType, vm.AssetType ? parseInt(cafm.util.getItemValue(vm.AssetType)) : cafm.enums.AssetType.All));
        }
        //#endregion
    }

    isAssetType(mk) {

        return mk == cafm.enums.ModelKey.AssetInfo ||
            mk == cafm.enums.ModelKey.ComputerAsset ||
            mk == cafm.enums.ModelKey.ElectricalAsset ||
            mk == cafm.enums.ModelKey.FurnitureAsset ||
            mk == cafm.enums.ModelKey.GeneralAsset ||
            mk == cafm.enums.ModelKey.PlantAsset ||
            mk == cafm.enums.ModelKey.ServiceAsset ||
            mk == cafm.enums.ModelKey.SystemAsset ||
            mk == cafm.enums.ModelKey.TelephoneAsset;
    }

    getDefaultScanType() {
        let kddl = $('select[name=ModelKey]').getKendoDropDownList();
        if (!kddl) return -1;
        let scanTypes = kddl.dataSource.data();
        let defaultType = Util.find(scanTypes, item => {
            return item.value == cafm.enums.ModelKey.AssetInfo;
        });

        if (!defaultType) {
            defaultType = scanTypes[0];
        }

        return parseInt(defaultType.value);
    }

    scan(eventArgs) {

        this.reader.scan();
        this.scanBtn.disabled = true;
        this.scanBtn.title = "Currently scanning...";
    }

    cancel(eventArgs) {

        this.close(eventArgs);
    }

    close(eventArgs) {
        cafm.views.closeActionWindow(null, isMobile ? () => { cafm.scanner.close(); } : null);
    }

    isUrlScanResult() {

        let value = this.reader.barcodeValue;
        return value && (value.startsWith("http://") || value.startsWith("https://"));
    }

    navigate(eventArgs) {
        let vm;
        if (this.isWorkOrderScan && (vm = $("#scan-result").getViewModel()).IsAsset) {
            cafm.assets.focusAssetInList(vm.Entity.ID);
            this.close(eventArgs);
        }
    }

    resetscan(eventArgs) {

        let me = this;
        me.scanAgainBtn.prop("disabled", true);
        this.getStream(() => {
            me.setFormStep(cafm.enums.ScanFormStep.Scanning);
            me.scanBtn.click();
            me.scanAgainBtn.prop("disabled", false);
        })
    }

    scanagain(eventArgs) {

        let me = this;
        me.scanAgainBtn.disabled = true;
        me.setFormStep(cafm.enums.ScanFormStep.Scanning);
        me.scanBtn.click();
        cafm.util.callFunctionAsync({
            func() {
                me.scanAgainBtn.disabled = false;
            },
            timeout: 1000
        })
    }

    assign(eventArgs) {

        let data = $("#scan-assign").getViewModel().toJSON();
        let me = this;
        cafm.actions.execute({
            elementId: "scan-assign",
            loaderTarget: cafm.views.getActionPanelElement(),
            url: cafm.url.api("barcode"),
            values: data,
            preventValidate: true,
            requestDelay: 500,
            success: function (assignedBarcode) {
                if (me.isWorkOrderScan && cafm.hd.workOrder.Security.Actions.AddAsset === true) {
                    cafm.assets.assetLookupSelected({
                        val: data.EntityID.toString(),
                        elementId: "scan-assign",
                        loaderSelector: "#assetsPlc",
                        callback: () => {
                            me.close(eventArgs);
                        }
                    });
                }
                else {
                    $("#scan-nav-btn").data("url", cafm.url.get(assignedBarcode.Path));
                    let act = () => {
                        me.setFormStep(cafm.enums.ScanFormStep.ScannedItemAssigned);
                        $("#scan-result-msg").showMessage({
                            title: me.settings.assignSuccessMessageTemplate.format(data.EntityDescription),
                            type: cafm.enums.MessageType.Success
                        });
                    };
                    if (isMobile) {
                        act();
                    }
                    else {
                        me.getStream(act);
                    }
                }
            }
        });
    }

    add(eventArgs, assetId) {
        if (this.isWorkOrderScan) {

            if (this.formStep == cafm.enums.ScanFormStep.ScannedItemRecognised) {
                assetId = $("#scan-result").getViewModel().Entity.ID;
            }
            if (!cafm.util.guidHasValue(assetId)) {
                console.error("Cannot add asset, there is no assetId");
                return;
            }
            // add the recognised asset
            cafm.assets.assetLookupSelected({
                val: assetId,
                elementId: "scan-result",
                loaderSelector: "#assetsPlc"
            });
            this.close(eventArgs);
        }
    }

    reassign(eventArgs) {
        // show the scanned item reassign form step
        this.setFormStep(cafm.enums.ScanFormStep.ScannedItemReassign);
    }

    editasset(eventArgs) {
        // show the scanned item asset update form step
        this.setFormStep(cafm.enums.ScanFormStep.ScannedItemAssetUpdate, $("#scan-result").getViewModel().toJSON().Entity);
    }

    saveasset(eventArgs) {
        let form = $("#scan-create-asset:visible");
        if (!form.length) form = $("#scan-update-asset");
        let data = form.getViewModel().toJSON();
        let me = this;
        let isUpdate = cafm.util.guidHasValue(data.ID),
            action = isUpdate ? "updateasset" : "createasset",
            nextFormStep = isUpdate ? cafm.enums.ScanFormStep.ScannedItemAssetUpdated : cafm.enums.ScanFormStep.ScannedItemAssetCreated;

        if ($("#roomGrid").length) {
            data.RoomIDs = $("#roomGrid").getSelectedGridRowIds();
        }

        cafm.actions.execute({
            elementId: "scan-create-asset",
            loaderSelector: `${cafm.scanner.loaderSelector()}, .winButtons [data-key=SaveAsset]`,
            url: cafm.url.api(`asset/${action}`),
            values: data,
            requestDelay: 500,
            preventValidationMessage: true,
            onInvalid() {
                let invMsg = form.find(".k-invalid-msg:hidden");
                if (!invMsg.length) return;
                let invItem = invMsg.first().closest(".k-item");
                if (invItem.data("key") == "AdditionalDetails") {
                    form.find(".k-item[data-key=AssetDetails] .scan-action-next-step").click();
                }
                else {
                    let panelBar = $("#scan-create-asset").getKendoPanelBar();
                    panelBar.element.find("> .k-item").each((i, el) => {
                        let item = $(el);
                        if (item.data("key") == invItem.data("key")) {
                            panelBar.expand(item);
                        }
                        else {
                            panelBar.collapse(item);
                        }
                    });
                }
            },
            success(stamp) {
                if (me.isWorkOrderScan) {
                    cafm.assets.assetLookupSelected({
                        val: stamp.ID,
                        elementId: "scan-create-asset",
                        loaderSelector: "#assetsPlc",
                        callback: () => {
                            me.close(eventArgs);
                        }
                    });
                }
                else {
                    $("#scan-nav-btn").data("url", cafm.url.get(`asset/${stamp.ID}`));
                    let act = () => {
                        if (!isUpdate) data.ID = stamp.ID;
                        me.setFormStep(nextFormStep, data);
                    };
                    if (isMobile) {
                        act();
                    }
                    else {
                        me.getStream(act);
                    }
                }
            }
        });
    }

    logworkorder(eventArgs) {
        let vm = $("#scan-result").getViewModel();
        if (vm.IsAsset)
            cafm.util.callFunctionAsync(() => cafm.hd.nav.logWorkOrderForAsset(vm.Entity.ID));
        else
            cafm.util.callFunctionAsync(() => cafm.hd.nav.logWorkOrderForLocality(vm.Entity.ID));
        this.close(eventArgs);
    }
}


class ScanReader {

    constructor(scanner) {
        this.scanner = scanner;
    }

    preScan() {
    }

    scan() {
    }

    postScan() {
        this.beep();
        this.scanner.postScan(this);
    }

    success(result, mockedHandler) {

        let value = isStr(result) ? result : result.text;
        let me = this;
        let ensuredValue;
        if (value.length > 20) {
            ensuredValue = value.substr(0, 20) + "...";
        }
        else {
            ensuredValue = value;
        }

        let ensured = me.ensureMessageAndLoaderElements(), msg = ensured.msg, loadTarg = ensured.loadTarg;

        msg.showMessage({
            title: this.scanner.settings.scannedBarcodeIsMessageTemplate.format(ensuredValue),
            type: cafm.enums.MessageType.Info,
            text: value,
            allowDetailToggle: true,
            hideDetails: true,
            transition: cafm.msg.Transition.None
        });

        // show the scanned item pending recognition form step
        me.scanner.setFormStep(cafm.enums.ScanFormStep.ScannedItemPending);

        let classicBarcodeId;

        //#region CFM-507 - handle old style QR code asset URLs
        // this version is flexible, allows for CAFM web external URL and the application root path changes
        if (value.startsWith("http://") || value.startsWith("https://")) {

            let location = cafm.url.getLocation(value),
                path = location.pathname,
                assetPath = "/asset/",
                assetIndex = path.indexOf(assetPath);

            if (assetIndex > -1) {
                path = path.substring(assetIndex);
                let pathSegment2Len = (path.length - assetPath.length);
                // check path starts with /asset/ path and that the second segment is the length of a guid (with dashes and without)
                if (pathSegment2Len == 36 || pathSegment2Len == 32) {
                    if (this.scanner.isWorkOrderScan) {
                        classicBarcodeId = path.substring(7);
                    }
                    else {
                        Util.callFunctionAsync({ func: () => { cafm.url.set(path); }, timeout: 1000 });
                        return;
                    }
                }
            }
        }
        //#endregion

        // if there's a mocked handler, use that
        if (mockedHandler) {
            mockedHandler(me);
            return;
        }

        cafm.cache.page('getCodeAction', getCodeAction, action => {
            action.set({
                loaderTarget: loadTarg[0],
                url: cafm.url.api(classicBarcodeId ? ("barcode/get/" + classicBarcodeId) : ("barcode/" + encodeURI(value))),
                success: function (barcode) {

                    if (cafm.util.guidHasValue(cafm.util.getReference("Entity.ID", barcode))) {
                        me.codeRecognised(barcode, me);
                    }
                    else {
                        me.codeNotRecognised(value, me);
                    }
                }
            });
        }).execute();
    }

    ensureMessageAndLoaderElements() {

        let sr = $("#scan-result-container"), msg = sr.find("> .msgPnl"), loadTarg = sr.find(".scan-load-target");
        if (!msg.length) {
            msg = $("<div>", { "class": "msgPnl" });
            sr.prepend(msg);
        }
        if (!loadTarg.length) {
            loadTarg = $("<div>", { "class": "scan-load-target" });
            loadTarg.insertAfter(msg);
        }

        return {
            msg, loadTarg
        };
    }

    codeRecognised(barcode, me) {

        // set is asset by checking model key
        barcode.IsAsset = me.scanner.isAssetType(barcode.ItemModelKey);

        let ensuredValue;
        if (barcode.Value.length > 20) {
            ensuredValue = barcode.Value.substr(0, 20) + "...";
        }
        else {
            ensuredValue = barcode.Value;
        }

        let ensured = me.ensureMessageAndLoaderElements(), msg = ensured.msg, loadTarg = ensured.loadTarg;
        let msgArgs = {
            type: me.scanner.isWorkOrderScan && !barcode.IsAsset ? cafm.enums.MessageType.Warning : cafm.enums.MessageType.Success,
            transition: cafm.msg.Transition.None
        };
        if (barcode.Value.length > 20) {
            msgArgs.text = barcode.Value;
            msgArgs.allowDetailToggle = true;
            msgArgs.hideDetails = true;
        }

        let msgTemplate;
        let aOrAn = ['a', 'e', 'i', 'o', 'u'].indexOf(barcode.ItemModelKeyDescription[0].toLowerCase()) > -1 ? "an" : "a";
        if (me.scanner.isWorkOrderScan && cafm.assets.getWorkOrderAsset(barcode.Entity.ID)) {
            msgTemplate = me.scanner.settings.barcodeMatchesAssetOnWoMessageTemplate;
        }
        else {
            msgTemplate = me.scanner.settings.barcodeMatchesMessageTemplate;

            if (me.scanner.isWorkOrderScan && barcode.IsAsset && barcode.Entity.IsHidden) {
                msgTemplate = `${msgTemplate}. ${cafm.res.str.TemplateThe0IsHiddenAndCannotBeAddedToThe1.format(barcode.ItemModelKeyDescription, cafm.res.str.LabelWorkOrder)}`;
                msgArgs.type = cafm.enums.MessageType.Warning;
            }
        }
        msgArgs.title = msgTemplate.format(ensuredValue, aOrAn, barcode.ItemModelKeyDescription);
        msg.showMessage(msgArgs);
        loadTarg.hideLoader();

        let helpdeskSettings = cafm.getClientSettings().helpdeskSettings,
            propertySettings = cafm.getClientSettings().propertySettings,
            viewAllowed;
        if (barcode.IsAsset && helpdeskSettings && !barcode.Entity.IsHidden) {
            viewAllowed = helpdeskSettings.assetSecuritySetting >= cafm.enums.SecuritySetting.View;
        }
        else if (propertySettings && !barcode.Entity.IsHidden) {
            viewAllowed = propertySettings[`canView${cafm.enums.getEnumKey(cafm.enums.ModelKey, barcode.ItemModelKey)}s`] === true;
        }
        else {
            viewAllowed = false;
        }

        if (viewAllowed) {
            // ensure barcode path for linkage and set on button
            barcode.Path = cafm.url.get(barcode.Path);
            $(".scan-entity-link-field a").removeClass("link-disabled");
            $(".scan-entity-link-field a,#scan-nav-btn").removeAttr("title");

            if (me.scanner.isWorkOrderScan && barcode.IsAsset) {
                $("#scan-nav-btn").prop("disabled", false).removeData("url");
            }
            else if (me.scanner.isWorkOrderScan && !barcode.IsAsset) {
                $("#scan-nav-btn").prop("disabled", true).removeData("url");
            }
            else {
                $("#scan-nav-btn").prop("disabled", false).data("url", barcode.Path);
            }

            if (me.scanner.isWorkOrderScan) {
                $(".scan-entity-link-field a").attr("target", "_blank");
            }
            else {
                $(".scan-entity-link-field a").removeAttr("target");
            }
        }
        else {
            let msg = barcode.Entity.IsHidden ?
                me.scanner.settings.notAllowedToViewHiddenItemTemplate.format(barcode.ItemModelKeyDescription) :
                me.scanner.settings.notAllowedToViewTemplate.format(barcode.ItemModelKeyCollectionDescription);
            let notAllowedMsg = (e) => {
                cafm.msg.showMessageInWindow({
                    title: msg,
                    type: cafm.enums.MessageType.Error
                });
                return false;
            }
            $("#scan-nav-btn").prop("disabled", true);
            $(".scan-entity-link-field a").addClass("link-disabled");
            $(".scan-entity-link-field a,#scan-nav-btn").attr("title", msg).click(notAllowedMsg);
        }

        // bind the view model
        $("#scan-result").bindViewModel(barcode);

        // if the user is allowed to create assets and this is a locality, cache it
        if (!me.scanner.isWorkOrderScan && cafm.scanner.isAllowed(cafm.scanner.SecurityCheck.CreateAsset) && !barcode.IsAsset) {
            cafm.hi.getLocality(barcode.Entity.ID, locality => {
                cafm.cache.set(me.scanner.scanLocalityCacheKey, locality);
            });
        }

        // show the scanned item recognised form step
        me.scanner.setFormStep(cafm.enums.ScanFormStep.ScannedItemRecognised, { barcode });
    }

    codeNotRecognised(barcode, me) {

        let ensuredValue;
        if (barcode.length > 20) {
            ensuredValue = barcode.substr(0, 20) + "...";
        }
        else {
            ensuredValue = barcode;
        }

        let ensured = me.ensureMessageAndLoaderElements(), msg = ensured.msg, loadTarg = ensured.loadTarg;
        let msgArgs = {
            type: cafm.enums.MessageType.Error,
            transition: cafm.msg.Transition.None
        };
        if (barcode.length > 20) {
            msgArgs.text = barcode;
            msgArgs.allowDetailToggle = true;
            msgArgs.hideDetails = true;
        }
        msgArgs.title = me.scanner.settings.barcodeNotRecognisedMessageTemplate.format(ensuredValue);
        msg.showMessage(msgArgs);
        loadTarg.hideLoader();

        // show the scanned item not recognised form step
        me.scanner.setFormStep(cafm.enums.ScanFormStep.ScannedItemNotRecognised, { barcode });
    }

    beep() {
        try {
            let sound = document.getElementById("beeper");
            if (sound) sound.play();
        }
        catch (err) {
            console.error(err.message);
        }
    }

    stop() {
    }
}

class ZXingDataBarReader extends ScanReader {

    constructor(scanner, cppReader) {
        super(scanner);
        this.cppReader = cppReader;
        this.readers = [];
    }

    scan() {
        this.stop();
        this.readers = [new ZXingJs.BrowserDataBarReader()];
        this.result = null;
        let me = this;
        for (let reader of me.readers) {
            reader.decodeFromRunningVideoSource(me.scanner.videoElement, me.scanner.stream)
                .then(result => { me.onSuccess(result); })
                .catch(error => { me.onError(error); });
        }
    }

    onSuccess(result) {
        this.result = result;
        this.barcodeValue = result.text;
        this.stop(true);
        let me = this;
        me.success(result);
        me.postScan();
    }

    onError(error) {
        console.error(`Scanning error: ${error}`);
        this.scanner.scanBtn.disabled = false;
        this.stop(true);
    }

    stop(stopCpp) {
        for (let reader of this.readers) {
            reader.stopDecode();
        }
        this.readers = [];
        if (stopCpp === true && this.cppReader) this.cppReader.stop();
    }
}

class ZXingGenericReader extends ScanReader {

    constructor(scanner) {
        super(scanner);
        this.dataBarReader = new ZXingDataBarReader(scanner, this);
    }

    preScan() {
        let me = this;
        me.barcodeValue = null;
        me.decodePtr = null;
        let decodeCallback = (ptr, len, resultIndex, resultCount) => {
            let result = new Uint8Array(ZXing.HEAPU8.buffer, ptr, len);
            let value = String.fromCharCode.apply(null, result);
            me.barcodeValue = value;
            me.stop(true);
            me.success(value);
            me.postScan();
        };
        let tick = () => {
            if (window.ZXing) {
                ZXing = isFunc(window.ZXing) ? window.ZXing() : window.ZXing;
                me.decodePtr = ZXing.Runtime.addFunction(decodeCallback);
            } else {
                setTimeout(tick, 10);
            }
        };
        tick();
        this.dataBarReader.preScan();
    }

    scan(secondPass) {
        if (window.ZXing == null) {
            this.scanner.scanBtn.disabled = false;
            cafm.msg.showMessageInWindow({
                title: `${cafm.res.str.LabelBarcode} reader is not ready`,
                type: cafm.enums.MessageType.Error
            });
            return;
        }
        let width = 0,
            height = 0;
        let barcodeCanvas = document.createElement("canvas");
        let videoElement = this.scanner.videoElement;
        barcodeCanvas.width = videoElement.videoWidth;
        barcodeCanvas.height = videoElement.videoHeight;

        let barcodeContext = barcodeCanvas.getContext('2d');
        let imageWidth = videoElement.videoWidth, imageHeight = videoElement.videoHeight;
        barcodeContext.drawImage(videoElement, 0, 0, imageWidth, imageHeight);

        // read barcode
        let imageData = barcodeContext.getImageData(0, 0, imageWidth, imageHeight).data;
        let image = ZXing._resize(imageWidth, imageHeight);
        for (let i = 0, j = 0; i < imageData.length; i += 4, j++) {
            ZXing.HEAPU8[image + j] = imageData[i];
        }
        // start databar reader
        if (!secondPass) {
            this.dataBarReader.scan();
        }
        // decode barcode
        let err = ZXing._decode_any(this.decodePtr);
        // handle error
        if (err && err !== -2) {
            console.error('ZXING error: ' + err);
            this.stop(true);
            this.scanner.scanagain();
        }
        // not really an error - just hasn't found barcode yet
        else if (err == -2) {
            let me = this;
            if (!this.dataBarReader.result) {
                me.scanTimeout = setTimeout(() => {
                    me.scan(true);
                }, 50);
            }
        }
    }

    stop(stopDb) {
        clearTimeout(this.scanTimeout);
        if (stopDb === true) this.dataBarReader.stop();
    }
}

let getCodeAction = () => {
    return new cafm.actions.Action({
        method: "GET",
        loaderText: cafm.scanner.searchingMsg
    });
}

cafm.scanner = {
    SecurityCheck: { View: 0, Add: 1, Assign: 2, CreateAsset: 3, UpdateAsset: 4, LogWorkOrder: 5 },
    get searchingMsg() { return `Searching for ${cafm.res.str.LabelBarcode}`; },
    open(event, settings) {
        if (cafm.scanner.opening) {
            if (event) {
                event.stopPropagation();
                event.preventDefault();
            }
            return false;
        }
        try {
            cafm.scanner.opening = true;
            let scannerUrl = cafm.url.get('scanner');
            if (settings && settings.parentId && settings.parentType) {
                scannerUrl += `?parentId=${settings.parentId}&parentType=${settings.parentType}`;
            }
            cafm.views.openActionWindow({
                url: scannerUrl,
                method: 'GET',
                winOptions: {
                    width: 900,
                    height: 400,
                    ensureWidth: true
                },
                onInit: element => {
                    body.addClass('scan-dialogue-active');
                    if (!isMobile) {
                        element.closest("#actionFormPlc").addClass("full-height");
                    }
                },
                onWindowClose: cafm.scanner.close
            });
            if (event) {
                event.stopPropagation();
                event.preventDefault();
            }
        }
        finally {
            cafm.util.callFunctionAsync({
                func: () => delete cafm.scanner.opening,
                timeout: 3000
            });
        }
        return false;
    },
    close() {
        body.removeClass('scan-dialogue-active');
        if (cafm.scanner.instance) cafm.scanner.instance.stop();
        $(window).off("resize.scanner");
        delete cafm.scanner.instance;
    },
    isAllowed(checkType, isWorkOrderScan, barcode) {
        let roleSettings = cafm.scanner.instance.settings.roleSettings;
        switch (checkType) {
            case cafm.scanner.SecurityCheck.Assign:
                return roleSettings.AssignEnabled === true && (!isWorkOrderScan || cafm.hd.workOrder.Security.Actions.AddAsset === true);
            case cafm.scanner.SecurityCheck.Add:
                return roleSettings.Enabled === true && isWorkOrderScan && cafm.hd.workOrder.Security.Actions.AddAsset === true && barcode.Entity.IsHidden !== true;
            case cafm.scanner.SecurityCheck.CreateAsset:
                return roleSettings.CreateAssetEnabled === true && (!isWorkOrderScan || cafm.hd.workOrder.Security.Actions.AddAsset === true);
            case cafm.scanner.SecurityCheck.UpdateAsset:
                return roleSettings.UpdateAssetEnabled === true && (!isWorkOrderScan || cafm.hd.workOrder.Security.Actions.AddAsset === true);
            case cafm.scanner.SecurityCheck.LogWorkOrder:
                return !isWorkOrderScan && roleSettings.LogWorkOrderEnabled === true && barcode.Entity.IsHidden !== true;
            default:
                return roleSettings.Enabled === true;
        }
    },
    formatBarcodeLink(barcodeElement) {
        let barcode;
        if (barcodeElement.length && (barcode = barcodeElement.text()).length > 24) {
            barcodeElement.html(`<a>${barcode}</a>`).click(() => {
                let field = barcodeElement.closestField().clone();
                field.find(".cfRoValSpan").text(barcode);
                cafm.views.openActionWindow({
                    closeOnOverlayClick: true,
                    winOptions: {
                        width: 600,
                        height: 300
                    },
                    content: field.wrap(`<fieldset class="readOnlyDetails view-barcode-fieldset"></fieldset>`).parent()
                        .append(`<menu class="cTb ${cafm.res.consts.CssClass_WindowButtons}" data-handler="cafm.toolbar.closeToolbar"><button class="btn" data-key="Close" type="button">${cafm.res.str.TextClose}</button></menu>`),
                    onLoad: (pnl) => {
                        cafm.util.callFunctionAsync({
                            func: () => {
                                $(`.${cafm.res.consts.CssClass_WindowButtons}`).setupToolbar();
                            },
                            timeout: 100
                        });
                    }
                })
            });
        }
    },
    loaderSelector() {
        return isMobile ? "#actionFormPlc" : "#actionPanel";
    },
    mock: {
        codeRecognised(mockRes) {
            let scanReady = () => {
                cafm.scanner.instance.setFormStep(cafm.enums.ScanFormStep.Scanning);
                cafm.util.callFunctionAsync({
                    func: () => {
                        cafm.handlers.remove("onScanReady");
                        cafm.scanner.instance.reader.beep();
                        cafm.scanner.instance.reader.success(mockRes.Value, (reader) => {
                            let loadTarg = reader.ensureMessageAndLoaderElements().loadTarg;
                            loadTarg.showLoader({
                                text: cafm.scanner.searchingMsg
                            });
                            cafm.util.callFunctionAsync({
                                func: () => {
                                    loadTarg.hideLoader();
                                    cafm.scanner.instance.reader.codeRecognised(mockRes, reader);
                                },
                                timeout: 1000
                            });
                        });
                    },
                    timeout: 500
                });
            };
            cafm.handlers.set("onScanReady", scanReady);
            if (cafm.views.isActionWindowOpen())
                scanReady();
            else
                cafm.scanner.open(null);
        },
        codeRecognisedOnWo(mockRes) {
            if (!$('#assetsPlc:visible').length) {
                cafm.msg.showMessageInWindow({ title: "Work Order assets section is not active", type: cafm.enums.MessageType.Error });
                return;
            }

            let scanReady = () => {
                cafm.scanner.instance.setFormStep(cafm.enums.ScanFormStep.Scanning);
                cafm.util.callFunctionAsync({
                    func: () => {
                        cafm.handlers.remove("onScanReady");
                        cafm.scanner.instance.reader.beep();
                        cafm.scanner.instance.reader.success(mockRes.Value, (reader) => {
                            let loadTarg = reader.ensureMessageAndLoaderElements().loadTarg;
                            loadTarg.showLoader({
                                text: cafm.scanner.searchingMsg
                            });
                            cafm.util.callFunctionAsync({
                                func: () => {
                                    loadTarg.hideLoader();
                                    cafm.scanner.instance.reader.codeRecognised(mockRes, reader);
                                },
                                timeout: 1000
                            });
                        });
                    },
                    timeout: 500
                });
            };
            cafm.handlers.set("onScanReady", scanReady);
            if (cafm.views.isActionWindowOpen())
                scanReady();
            else
                cafm.scanner.open(null, {
                    parentId: cafm.hd.workOrder.ID,
                    parentType: cafm.enums.ModelKey.WorkOrder
                });
        },
        codeNotRecognised(code) {
            let scanReady = () => {
                cafm.scanner.instance.setFormStep(cafm.enums.ScanFormStep.Scanning);
                cafm.util.callFunctionAsync({
                    func: () => {
                        cafm.handlers.remove("onScanReady");
                        cafm.scanner.instance.reader.beep();
                        cafm.scanner.instance.reader.success(code, (reader) => {
                            let loadTarg = reader.ensureMessageAndLoaderElements().loadTarg;
                            loadTarg.showLoader({
                                text: cafm.scanner.searchingMsg
                            });
                            cafm.util.callFunctionAsync({
                                func: () => {
                                    loadTarg.hideLoader();
                                    cafm.scanner.instance.reader.codeNotRecognised(code, reader);
                                },
                                timeout: 1000
                            });
                        });
                    },
                    timeout: 250
                });
            }
            cafm.handlers.set("onScanReady", scanReady);
            if (cafm.views.isActionWindowOpen())
                scanReady();
            else
                cafm.scanner.open(null);
        },
        codeNotRecognisedOnWo(code) {

            if (!$('#assetsPlc:visible').length) {
                cafm.msg.showMessageInWindow({ title: "Work Order assets section is not active", type: cafm.enums.MessageType.Error });
                return;
            }

            let scanReady = () => {
                cafm.scanner.instance.setFormStep(cafm.enums.ScanFormStep.Scanning);
                cafm.util.callFunctionAsync({
                    func: () => {
                        cafm.handlers.remove("onScanReady");
                        cafm.scanner.instance.reader.beep();
                        cafm.scanner.instance.reader.success(code, (reader) => {
                            let loadTarg = reader.ensureMessageAndLoaderElements().loadTarg;
                            loadTarg.showLoader({
                                text: cafm.scanner.searchingMsg
                            });
                            cafm.util.callFunctionAsync({
                                func: () => {
                                    loadTarg.hideLoader();
                                    cafm.scanner.instance.reader.codeNotRecognised(code, reader);
                                },
                                timeout: 1000
                            });
                        });
                    },
                    timeout: 250
                });
            }
            cafm.handlers.set("onScanReady", scanReady);
            if (cafm.views.isActionWindowOpen())
                scanReady();
            else
                cafm.scanner.open(null, {
                    parentId: cafm.hd.workOrder.ID,
                    parentType: cafm.enums.ModelKey.WorkOrder
                });
        }
    }
}

cafm.scanner.mock